<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Enunciados</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
        <div class="table-responsive">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
            <div class="col-md-3">
              <ResourceSearchs :routeApi="'statementformula'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
            </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <b-table hover :items="resources"
          :fields="fields"
          :per-page="0"
          :current-page="currentPage"
          >
           <template v-slot:cell(actions)="row">
            <b-button class="btn btn-icon btn-icon-mini btn-round btn-info" @click="info(row.item, row.index, $event.target)">
              <i class="zmdi zmdi-edit"></i>
            </b-button>
             <b-button class="btn btn-icon btn-icon-mini btn-round btn-danger" @click="ondelete(row.item)">
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
  <!-- Info modal -->
  <b-modal :id="infoModal.id" size="xl" :title="infoModal.title" hide-footer>
      <div class="modal-body">
        <ValidationObserver ref="formValidation">
        <b-row>

          <b-col>
          <div>
            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
              <label for="">Nombre</label>
              <b-form-input
                id="NOMBRE"
                v-model="selectedItem.NOMBRE"
                placeholder="Nombre..." />
              <span class="validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <br />
          <div>
            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
              <label>Texto del enunciado</label>
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="selectedItem.TEXTOS_ID_ENUNCIADO !== null && selectedItem.TEXTOS_ID_ENUNCIADO !== 0"
                          @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_ENUNCIADO)"/>
                <input type="text" v-bind:value="getTranslation(selectedItem.text.TEXTO_ENUNCIADO)"
                  disabled class="form-control" />
                <searchtexts class="pl-2" idModal="mdlSearchTextEnunciado"
                  v-on:selected="onSelectedTextEnunciado($event)">
                </searchtexts>
              </div>
              <span class="validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div>
            <label>Audio Enunciado</label>
            <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
              <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.AUDIOS_ID !== null && selectedItem.AUDIOS_ID !== 0"
                        @click="openResourceWithParam('audios', selectedItem.AUDIOS_ID)"/>
              <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.AUDIOS_ID !== 0 && selectedItem.AUDIOS_ID !== null" @click="cleanAudio()" />
              <audio :src="getTranslation(selectedItem.text.AUDIO_ENUNCIADO)" controls="controls"
                              style="width:100%" type="audio/mpeg" preload="preload" v-if="selectedItem.AUDIOS_ID !== 0 && selectedItem.AUDIOS_ID !== null">
              </audio>
              <span v-if="selectedItem.AUDIOS_ID === 0 || selectedItem.AUDIOS_ID === null">Sin audio</span>
              <searchaudios class="pl-2" idModal="mdlSearchAudio"
                v-on:selected="onSelectedAudio($event)">
              </searchaudios>
            </div>
          </div>
          <div>
            <label>Imagen Enunciado</label>
            <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
              <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.IMAGENES_ID !== null && selectedItem.IMAGENES_ID !== 0"
                        @click="openResourceWithParam('images', selectedItem.IMAGENES_ID)"/>
              <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.IMAGENES_ID !== 0 && selectedItem.IMAGENES_ID !== null" @click="cleanImage()" />
              <div class="image">
                  <img :src="getTranslation(selectedItem.text.IMAGEN_ENUNCIADO)" alt="img"
                  style="width:110px;height:110px" class="img-fluid" v-if="selectedItem.IMAGENES_ID !== 0 && selectedItem.IMAGENES_ID !== null">
                  <span v-if="selectedItem.IMAGENES_ID === 0 || selectedItem.IMAGENES_ID === null">Sin imagen</span>
              </div>
              <searchimages class="pl-2" idModal="mdlSearchImageEnunciado"
                v-on:selected="onSelectedImageEnunciado($event)">
              </searchimages>
            </div>
          </div>
          <br />
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            v-model="selectedItem.SUB"
            id="SUB">
            <label class="custom-control-label" for="SUB">
              Subproblema</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            v-model="selectedItem.CC"
            id="CC">
            <label class="custom-control-label" for="CC">
              Cambiar cantidades</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            v-model="selectedItem.CU"
            id="CU">
            <label class="custom-control-label" for="CU">
              Cambiar unidades</label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
            v-model="selectedItem.EST"
            id="EST">
            <label class="custom-control-label" for="EST">
              Estimación</label>
          </div>
          <br />
          <div v-if="selectedItem.EST === 1 || selectedItem.EST === true">
            <div>
              <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                <label>Respuesta Correcta</label>
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                            v-if="selectedItem.TEXTOS_ID_EST_COR !== null && selectedItem.TEXTOS_ID_EST_COR !== 0"
                            @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_EST_COR)"/>
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.TEXTOS_ID_EST_COR !== null && selectedItem.TEXTOS_ID_EST_COR !== 0"
                        @click="cleanResponse(0)"/>
                  <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_COR)"
                  disabled class="form-control" />
                  <searchtexts class="pl-2" idModal="mdlSearchTextResponse"
                    v-on:selected="onSelectedTextResponse($event, 0)">
                  </searchtexts>
                </div>
                <span class="validation-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                <label>Respuesta erronea 1</label>
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                            v-if="selectedItem.TEXTOS_ID_EST_INC1 !== null && selectedItem.TEXTOS_ID_EST_INC1 !== 0"
                            @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_EST_INC1)"/>
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.TEXTOS_ID_EST_INC1 !== null && selectedItem.TEXTOS_ID_EST_INC1 !== 0"
                        @click="cleanResponse(1)"/>
                  <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_INC1)"
                  disabled class="form-control" />
                  <searchtexts class="pl-2" idModal="mdlSearchTextResponse_INC1"
                    v-on:selected="onSelectedTextResponse($event, 1)">
                  </searchtexts>
                </div>
                <span class="validation-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                <label>Respuesta erronea 2</label>
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                            v-if="selectedItem.TEXTOS_ID_EST_INC2 !== null && selectedItem.TEXTOS_ID_EST_INC2 !== 0"
                            @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_EST_INC2)"/>
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.TEXTOS_ID_EST_INC2 !== null && selectedItem.TEXTOS_ID_EST_INC2 !== 0"
                        @click="cleanResponse(2)"/>
                  <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_INC2)"
                  disabled class="form-control" />
                  <searchtexts class="pl-2" idModal="mdlSearchTextResponse_INC2"
                    v-on:selected="onSelectedTextResponse($event, 2)">
                  </searchtexts>
                </div>
                <span class="validation-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                <label>Respuesta erronea 3</label>
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                            v-if="selectedItem.TEXTOS_ID_EST_INC3 !== null && selectedItem.TEXTOS_ID_EST_INC3 !== 0"
                            @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_EST_INC3)"/>
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.TEXTOS_ID_EST_INC3 !== null && selectedItem.TEXTOS_ID_EST_INC3 !== 0"
                        @click="cleanResponse(3)"/>
                  <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_INC3)"
                  disabled class="form-control" />
                  <searchtexts class="pl-2" idModal="mdlSearchTextResponse_INC3"
                    v-on:selected="onSelectedTextResponse($event, 3)">
                  </searchtexts>
                </div>
                <span class="validation-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                <label>Respuesta erronea 4</label>
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                            v-if="selectedItem.TEXTOS_ID_EST_INC4 !== null && selectedItem.TEXTOS_ID_EST_INC4 !== 0"
                            @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID_EST_INC4)"/>
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="selectedItem.TEXTOS_ID_EST_INC4 !== null && selectedItem.TEXTOS_ID_EST_INC4 !== 0"
                        @click="cleanResponse(4)"/>
                  <input type="text" v-bind:value="getTranslation(selectedItem.responses.TEXTOS_EST_INC4)"
                  disabled class="form-control" />
                  <searchtexts class="pl-2" idModal="mdlSearchTextResponse_INC4"
                    v-on:selected="onSelectedTextResponse($event, 4)">
                  </searchtexts>
                </div>
                <span class="validation-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
        </b-col>
        <b-col>
          <div>
            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
              Respuesta Unidad
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.RESPUESTAU_ID !== null && selectedItem.RESPUESTAU_ID !== 0"
                        @click="openResourceWithParam('unitmath', selectedItem.RESPUESTAU_ID)"/>
                <input type="text" v-bind:value="getTranslation(selectedItem.responses.RESPUESTAU_TEXTO)"
                disabled class="form-control"/>
                <searchunitmath class="pl-2" idModal="mdlSearchUnitMathResponse"
                  v-on:selected="onSelectedResponseUnitMath($event)">
                </searchunitmath>
              </div>
              <span class="validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <br />
          <div>
            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
              <label>Fórmula</label>
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="selectedItem.FORMULAS_ID !== null && selectedItem.FORMULAS_ID !== 0"
                          @click="openResourceWithParam('formulas', selectedItem.FORMULAS_ID)"/>
                <b-form-textarea
                    id="textarea"
                    disabled class="form-control"
                    v-model="selectedItem.text.FORMULA_TEXTO"
                    placeholder="Fórmula..."
                    rows="5"
                    max-rows="5"
                    :readonly=true >
                </b-form-textarea>
                <searchformulas class="p-2" idModal="mdlSearchFormula"
                  v-on:selected="onSelectedFormula($event)">
                </searchformulas>
              </div>
              <span class="validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <br />
          <div>
            <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
              <label>Plantilla</label>
              <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="selectedItem.PLANTILLAS_ID !== null && selectedItem.PLANTILLAS_ID !== 0"
                          @click="openResourceWithParam('templates', selectedItem.PLANTILLAS_ID)"/>
                <b-form-textarea
                    id="textarea"
                    disabled class="form-control"
                    v-bind:value="getTranslation(selectedItem.text.PLANTILLA)"
                    placeholder="Texto de la plantilla..."
                    rows="9"
                    max-rows="9"
                    :readonly=true >
                </b-form-textarea>
                <searchtemplates class="p-2" idModal="mdlSearchTemplate"
                  v-on:selected="onSelectedTemplate($event)">
                </searchtemplates>
              </div>
              <span class="validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <br/>
          <div>
            <div class="col-md-12 d-inline-flex align-items-center p-1 m-0 pr-4">
              <span class="w-50">Respuesta 1</span>
              <input type="text" v-bind:value="selectedItem.INC1" maxlength="20" class="form-control" />
            </div>
          </div>
          <div>
            <div class="col-md-12 d-inline-flex align-items-center p-1 m-0 pr-4">
              <span class="w-50">Respuesta 2</span>
              <input type="text" v-bind:value="selectedItem.INC2" maxlength="20" class="form-control" />
            </div>
          </div>
          <div>
            <div class="col-md-12 d-inline-flex align-items-center p-1 m-0 pr-4">
              <span class="w-50">Respuesta 3</span>
              <input type="text" v-bind:value="selectedItem.INC3" maxlength="20" class="form-control" />
            </div>
          </div>
          <div>
            <div class="col-md-12 d-inline-flex align-items-center p-1 m-0 pr-4">
              <span class="w-50">Respuesta 4</span>
              <input type="text" v-bind:value="selectedItem.INC4" maxlength="20" class="form-control" />
            </div>
          </div>
        </b-col>

      </b-row>

      <hr>
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 0" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col col lg="3">
                Cantidad
                <b-form-input v-model="arrayEleOperation[index].CANTIDAD"
                  type="text">
                </b-form-input>
              </b-col>
              <b-col col lg="9">
                Unidad
                <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="arrayEleOperation[index].UNIDADES_ID !== null && arrayEleOperation[index].UNIDADES_ID !== 0"
                        @click="openResourceWithParam('unitmath', arrayEleOperation[index].UNIDADES_ID)"/>
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].UNIDADES_ID !== null"
                    @click="cleanUnitResponse(index)"/>
                  <input type="text"
                  v-bind:value="getTranslation(arrayEleOperation[index].RESPUESTAU_TEXTO)"
                  disabled class="form-control" />
                  <searchunitmath class="pl-2" :idModal="'mdlSearchUnitMath_' + index"
                    v-on:selected="onSelectedUnitMath($event, index)">
                  </searchunitmath>
                </div>
              </b-col>
            </b-row>
        </div>
      </div>
        <br />
        <label for="Tag">
        <br>
          Etiquetas</label>
            <div>
            <vue-tags-input
              v-model="tag"
              :tags="tags"
              :autocomplete-items="autocompleteItems"
              @tags-changed="update"
            />
          </div>
        <div class="modal-footer">
          <button type="button" @click="save"
          class="btn btn-info btn-round waves-effect">
            Guardar</button>
          <b-button class="btn btn-default btn-round waves-effect" block
          @click="$bvModal.hide('info-modal')">Cerrar</b-button>
        </div>
      </ValidationObserver>
    </div>
  </b-modal>
</div>

</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import VueTagsInput from '@johmun/vue-tags-input';
import searchtexts from '../texts/SearchTexts.vue';
import searchimages from '../images/SearchImages.vue';
import searchaudios from '../audios/SearchAudios.vue';
import searchtemplates from '../templates/SearchTemplates.vue';
import searchunitmath from '../units/SearchUnitmath.vue';
import searchformulas from '../formulas/SearchFormulas.vue';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  components: {
    VueTagsInput,
    searchtexts,
    searchimages,
    searchaudios,
    searchtemplates,
    searchunitmath,
    searchformulas,
    ResourceSearchs,
    ValidationProvider,
    ValidationObserver,
  },
  name: 'gridStatementFormula',
  mixins: [searchMixin, translationMixin],
  data() {
    return {
      perPage: 20,
      rows: 0,
      currentPage: 1,
      selectedNumOpertion: 0,
      arrayEleOperation: [],
      problemstype: [], // Coleccion con los tipos de problemas
      numerationstype: [], // Colección con los tipos de numeración
      fields: [
        { key: 'NOMBRE', label: 'Nombre' },
        { key: 'NOMBRE_FORMULA', label: 'Fórmula' },
        { key: 'SUB', label: 'Subproblema' },
        { key: 'actions', label: 'Acciones', tdClass: 'tdActionClass' },
      ],
      resources: [],
      selectedItem: {
        ID: null,
        NOMBRE: null, // Nombre descriptivo para buscar
        TEXTOS_ID_ENUNCIADO: null, // Enlace al enunciado
        SUB: false, // Es subproblema: 0 No 1 Si
        CC: false, // Permite cambiar cantidades en el ejercicio: 0 No 1 Si
        CU: false, // Permite cambiar unidades en el ejercicio: 0 No 1 Si
        EST: false, // Tiene respuesta personalizadas (estimación)
        INC1: null, // Respuesta numerica
        INC2: null, // Respuesta numerica
        INC3: null, // Respuesta numerica
        INC4: null, // Respuesta numerica
        TEXTOS_ID_EST_COR: null, // Enlace al texto de la respuesta correcta
        TEXTOS_ID_EST_INC1: null, // Enlace al texto de la respuesta incorrecta
        TEXTOS_ID_EST_INC2: null, // Enlace al texto de la respuesta incorrecta
        TEXTOS_ID_EST_INC3: null, // Enlace al texto de la respuesta incorrecta
        TEXTOS_ID_EST_INC4: null, // Enlace al texto de la respuesta incorrecta
        RESPUESTAU_ID: null, // Enlace a la unidad de la respuesta
        FORMULAS_ID: null, // Enlace a la fórmula
        AUDIOS_ID: null, // Enlace al audio que acompaña al enunciado, 0 si no tiene
        IMAGENES_ID: null, // Enlace a la imagen que acompaña al enunciado, 0 si no tiene
        PLANTILLAS_ID: null, // Enlace a las plantillas
        text: { // Used for display
          TEXTO_ENUNCIADO: [],
          AUDIO_ENUNCIADO: [],
          IMAGEN_ENUNCIADO: [],
          PLANTILLA: [],
          FORMULA_TEXTO: null,
        },
        responses: { // Used for display
          TEXTOS_EST_COR: [],
          TEXTOS_EST_INC1: [],
          TEXTOS_EST_INC2: [],
          TEXTOS_EST_INC3: [],
          TEXTOS_EST_INC4: [],
          RESPUESTAU_TEXTO: [],
        },
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      taglist: '',
      tags: [],
      newTags: [],
      newTags2: [],
      tagslist: [],
      autocompleteItems: [],
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        NOMBRE: null,
        CANTIDAD: null,
        UNIDADES_ID: null,
        RESPUESTAU_TEXTO: [],
      });
    },
    /**
    * Obtener tipos de problema
     */
    async getProblemsType() {
      this.loading = true;
      try {
        const response = await this.axios.get('problemstype/getproblemstype');
        this.problemstype = response.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    /**
     * Obtener tipos de numeracion
     */
    async getNumerationType() {
      this.loading = true;
      try {
        const response = await this.axios.get('numerationtype/getnumerationtype');
        this.numerationstype = response.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    /**
    * @method onSelectedText
    * @description Al seleccionar un texto
    */
    onSelectedTextEnunciado(itemSelected) {
      this.selectedItem.TEXTOS_ID_ENUNCIADO = itemSelected.ID;
      this.selectedItem.text.TEXTO_ENUNCIADO = itemSelected.TEXTOS;
      this.$root.$emit('bv::hide::modal', 'mdlSearchTextEnunciado');
    },
    onSelectedTextResponse(itemSelected, id) {
      switch (id) {
        case 0:
          // Respuesta Correcta
          this.selectedItem.TEXTOS_ID_EST_COR = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_COR = itemSelected.TEXTOS;
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_Correcta');
          break;
        case 1:
          // Respuesta Erronea 1
          this.selectedItem.TEXTOS_ID_EST_INC1 = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_INC1 = itemSelected.TEXTOS;
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_INC1');
          break;
        case 2:
          // Respuesta Erronea 2
          this.selectedItem.TEXTOS_ID_EST_INC2 = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_INC2 = itemSelected.TEXTOS;
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_INC2');
          break;
        case 3:
          // Respuesta Erronea 3
          this.selectedItem.TEXTOS_ID_EST_INC3 = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_INC3 = itemSelected.TEXTOS;
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_INC3');
          break;
        case 4:
          // Respuesta Erronea 4
          this.selectedItem.TEXTOS_ID_EST_INC4 = itemSelected.ID;
          this.selectedItem.responses.TEXTOS_EST_INC4 = itemSelected.TEXTOS;
          this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse_INC4');
          break;
        default:
          break;
      }
      this.$root.$emit('bv::hide::modal', 'mdlSearchTextResponse');
    },
    /**
    * @method cleanAudio
    * @description Limpia el audio
    */
    cleanAudio() {
      this.selectedItem.AUDIOS_ID = 0;
      this.selectedItem.text.AUDIO_ENUNCIADO = [];
    },
    /**
    * @method onSelectedAudio
    * @description Al seleccionar un audio
    */
    onSelectedAudio(itemSelected) {
      this.selectedItem.AUDIOS_ID = itemSelected.ID;
      this.selectedItem.text.AUDIO_ENUNCIADO = [];
      this.selectedItem.text.AUDIO_ENUNCIADO = itemSelected.FICHERO;
      this.$root.$emit('bv::hide::modal', 'mdlSearchAudio');
    },
    /**
    * @method cleanImage
    * @description Limpia la imagen
    */
    cleanImage() {
      this.selectedItem.IMAGENES_ID = 0;
      this.selectedItem.text.IMAGEN_ENUNCIADO = [];
    },
    /**
    * @method onSelectedImageEnunciado
    * @description Al seleccionar una imagen
    */
    onSelectedImageEnunciado(itemSelected) {
      this.selectedItem.IMAGENES_ID = itemSelected.ID;
      this.selectedItem.text.IMAGEN_ENUNCIADO = itemSelected.FICHERO;
      this.$root.$emit('bv::hide::modal', 'mdlSearchImageEnunciado');
    },
    /**
     * Seleccionar una plantilla
     */
    onSelectedTemplate(itemSelected) {
      this.selectedItem.PLANTILLAS_ID = itemSelected.ID;
      this.selectedItem.text.PLANTILLA = itemSelected.PLANTILLA;
      this.$root.$emit('bv::hide::modal', 'mdlSearchTemplate');
    },
    onSelectedFormula(itemSelected) {
      this.selectedItem.FORMULAS_ID = itemSelected.ID;
      this.selectedItem.text.FORMULA_TEXTO = itemSelected.NOMBRE;
      this.$root.$emit('bv::hide::modal', 'mdlSearchFormula');
    },
    onSelectedResponseUnitMath(itemSelected) {
      this.selectedItem.RESPUESTAU_ID = itemSelected.ID;
      this.selectedItem.responses.RESPUESTAU_TEXTO = itemSelected.TEXTO_SINGULAR;
      this.$root.$emit('bv::hide::modal', 'mdlSearchUnitMathResponse');
    },
    onSelectedUnitMath(itemSelected, posicion) {
      this.arrayEleOperation[posicion].UNIDADES_ID = itemSelected.ID;
      this.arrayEleOperation[posicion].RESPUESTAU_TEXTO = itemSelected.TEXTO_SINGULAR;
      this.$root.$emit('bv::hide::modal', `mdlSearchUnitMath_${posicion}`);
    },
    onNew() {
      this.limpiar();
      this.infoModal.title = 'Nuevo enunciado de Fórmula';
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    cleanUnit() {
      this.selectedItem.RESPUESTAU_ID = null;
      this.selectedItem.responses.RESPUESTAU_TEXTO = [];
    },
    cleanUnitResponse(index) {
      this.arrayEleOperation[index].UNIDADES_ID = null;
      this.arrayEleOperation[index].RESPUESTAU_TEXTO = [];
    },
    cleanResponse(id) {
      switch (id) {
        case 0:
          this.selectedItem.TEXTOS_ID_EST_COR = null;
          this.selectedItem.responses.TEXTOS_EST_COR = [];
          break;
        case 1:
          this.selectedItem.TEXTOS_ID_EST_INC1 = null;
          this.selectedItem.responses.TEXTOS_EST_INC1 = [];
          break;
        case 2:
          this.selectedItem.TEXTOS_ID_EST_INC2 = null;
          this.selectedItem.responses.TEXTOS_EST_INC2 = [];
          break;
        case 3:
          this.selectedItem.TEXTOS_ID_EST_INC3 = null;
          this.selectedItem.responses.TEXTOS_EST_INC3 = [];
          break;
        case 4:
          this.selectedItem.TEXTOS_ID_EST_INC4 = null;
          this.selectedItem.responses.TEXTOS_EST_INC4 = [];
          break;
        default:
          break;
      }
    },
    limpiar() {
      this.selectedItem.ID = null;
      this.selectedItem.NOMBRE = null;
      this.selectedItem.TEXTOS_ID_ENUNCIADO = null;
      this.selectedItem.SUB = false;
      this.selectedItem.CC = false;
      this.selectedItem.CU = false;
      this.selectedItem.EST = false;
      this.selectedItem.INC1 = null;
      this.selectedItem.INC2 = null;
      this.selectedItem.INC3 = null;
      this.selectedItem.INC4 = null;
      this.selectedItem.TEXTOS_ID_EST_COR = null;
      this.selectedItem.TEXTOS_ID_EST_INC1 = null;
      this.selectedItem.TEXTOS_ID_EST_INC2 = null;
      this.selectedItem.TEXTOS_ID_EST_INC3 = null;
      this.selectedItem.TEXTOS_ID_EST_INC4 = null;
      this.selectedItem.RESPUESTAU_ID = null;
      this.selectedItem.FORMULAS_ID = null;
      this.selectedItem.AUDIOS_ID = null;
      this.selectedItem.IMAGENES_ID = null;
      this.selectedItem.PLANTILLAS_ID = null;
      // Text to show on forms
      this.selectedItem.text.TEXTO_ENUNCIADO = [];
      this.selectedItem.text.AUDIO_ENUNCIADO = [];
      this.selectedItem.text.IMAGEN_ENUNCIADO = [];
      this.selectedItem.text.PLANTILLA = [];
      this.selectedItem.text.FORMULA_TEXTO = null;
      // responses
      this.selectedItem.responses.TEXTOS_EST_COR = [];
      this.selectedItem.responses.TEXTOS_EST_INC1 = [];
      this.selectedItem.responses.TEXTOS_EST_INC2 = [];
      this.selectedItem.responses.TEXTOS_EST_INC3 = [];
      this.selectedItem.responses.TEXTOS_EST_INC4 = [];
      this.tag = '';
      this.tags = [];
      this.selectedNumOpertion = 0;
      this.arrayEleOperation = [];
    },
    async ondelete(item) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        /** Elimino los tags asociados */
        const url = `Tagsstatementformula/deleteTags/${item.ID}`;
        this.axios.get(url);

        this.loading = true;
        const response = await this.axios.post('statementformula/delete', { ID: item.ID });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async info(item, index, button) {
      this.infoModal.title = 'Editar Enunciado';

      this.loading = true;
      try {
        const response = await this.axios.get('formulastatements/getformulastatement', {
          params: {
            id: item.ID,
          },
        });
        this.selectedItem = response.data.content;
        this.selectedNumOpertion = response.data.elements.length;
        this.arrayEleOperation = [];
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            NOMBRE: element.NOMBRE,
            POSICION: element.POSICION,
            CANTIDAD: element.CANTIDAD,
            UNIDADES_ID: element.UNIDADES_ID,
            RESPUESTAU_TEXTO: element.RESPUESTAU_TEXTO,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el enunciado de fórmula', { type: 'warning' });
      }

      await this.getExistingTags(item.ID);
      this.loading = false;
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    async save() {
      this.$refs.formValidation.validate().then(async (success) => {
        if (!success) {
          return;
        }
        this.loading = true;
        const elemntsoperation = [];
        this.arrayEleOperation.forEach((element) => {
          if (element.POSICION <= this.arrayEleOperation.length) {
            elemntsoperation.push({
              // ID: element.ID,
              POSICION: element.POSICION,
              CANTIDAD: element.CANTIDAD,
              UNIDADES_ID: element.UNIDADES_ID,
              ENUNCIADOS_FORMULA_ID: -1,
            });
          }
        });
        const unitData = {
          ID: this.selectedItem.ID || -1,
          NOMBRE: this.selectedItem.NOMBRE,
          TEXTOS_ID_ENUNCIADO: this.selectedItem.TEXTOS_ID_ENUNCIADO,
          SUB: this.selectedItem.SUB,
          CC: this.selectedItem.CC,
          CU: this.selectedItem.CU,
          EST: this.selectedItem.EST,
          INC1: this.selectedItem.INC1,
          INC2: this.selectedItem.INC2,
          INC3: this.selectedItem.INC3,
          INC4: this.selectedItem.INC4,
          TEXTOS_ID_EST_COR: this.selectedItem.TEXTOS_ID_EST_COR,
          TEXTOS_ID_EST_INC1: this.selectedItem.TEXTOS_ID_EST_INC1,
          TEXTOS_ID_EST_INC2: this.selectedItem.TEXTOS_ID_EST_INC2,
          TEXTOS_ID_EST_INC3: this.selectedItem.TEXTOS_ID_EST_INC3,
          TEXTOS_ID_EST_INC4: this.selectedItem.TEXTOS_ID_EST_INC4,
          RESPUESTAU_ID: this.selectedItem.RESPUESTAU_ID,
          FORMULAS_ID: this.selectedItem.FORMULAS_ID,
          AUDIOS_ID: (this.selectedItem.AUDIOS_ID === null) ? 0 : this.selectedItem.AUDIOS_ID,
          IMAGENES_ID: (this.selectedItem.IMAGENES_ID === null) ? 0 : this.selectedItem.IMAGENES_ID,
          PLANTILLAS_ID: this.selectedItem.PLANTILLAS_ID,
          ELEMENTOS: elemntsoperation,
        };
        try {
          const response = await this.axios.post('statementformula/store', unitData);
          if (response.data.status === 'success') {
            // Solo si esta creando agrego el evento
            if (this.selectedItem.ID === -1 || this.selectedItem.ID === null) {
              const bc = new BroadcastChannel('new_resource_statements_formula');
              bc.postMessage({
                ID: response.data.id,
                NOMBRE: this.selectedItem.NOMBRE,
                SUB: this.selectedItem.SUB,
                FORMULAS_ID: this.selectedItem.FORMULAS_ID,
              });
            }

            const url = `Tagsstatementformula/deleteTags/${response.data.id}`;
            const url2 = 'Tagsstatementformula/saveTag';

            this.axios.get(url);
            this.newTags.forEach((a) => {
              this.axios.get(`Tags/findTagByName/${a.text}`,
                { name: a.text }).then((resp) => {
                if (resp.data.status === 'success') {
                  this.axios.post(url2, { id: resp.data.id, idtexto: response.data.id });
                } else {
                  this.axios.post(url2, { id: a.key, idtexto: response.data.id });
                }
              });
            });

            this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
            this.$root.$emit('bv::hide::modal', this.infoModal.id);
            this.limpiar();

            // Auto close if coming from a create event
            if (this.bAutoClose) {
              window.open('', '_self').close();
            }

            await this.getPostData();
          } else {
            this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
          }
          this.loading = false;
        } catch (e) {
          const resp = e;
          if (!resp.body.Ok) {
            this.$toasted.show(resp.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
          }
          this.loading = false;
        }
      });
    },
    async getContents() {
      this.loading = true;

      try {
        const response = await this.axios.get('statementformula');
        this.resources = response.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async getPostData() {
      this.loading = true;
      try {
        const response = await this.axios.get('statementformula', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    async getExistingTags(idtxt) {
      const url = `Tagsstatementformula/findByStatementFormula/${idtxt}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_statements_formula_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    if (this.$route.params.id != null) {
      const item = {
        ID: this.$route.params.id,
      };
      this.info(item, null, null);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
};
</script>
<style>
  .tdActionClass{
    width: 180px;
    text-align: center
  }
</style>
